import Application from "../../Application";
import { IFormStructureSection } from "../../model/report/applicantdata/FormStructureSection";
import { IFormTypeItem } from "../../model/report/FormTypeItem";
import { IReport6Applicant } from "../../model/report/Report6Applicant";
import { IReportingPeriodItem } from "../../model/report/ReportingPeriodItem";
import { IReport7ApplicantPresentationModel } from "../../presenter/report/model/Report7ApplicantPresentationModel";
import Report7Presenter, {
  IReport7Presenter
} from "../../presenter/report/Report7Presenter";
import { INotificationService } from "../../service/notification/NotificationService";
import { IReportService } from "../../service/report/ReportService";

export default class ShowReport7PageInteractor {
  private application: Application;
  private output?: IReport7Presenter;
  private notificationService: INotificationService;
  private reportService: IReportService;

  constructor(application, notificationService, reportService) {
    this.application = application;
    this.notificationService = notificationService;
    this.reportService = reportService;
  }

  async getReportingPeriods() {
    try {
      return this.reportService.getReportingPeriodList();
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = Report7Presenter({
      application: this.application,
      initialState: {
        reportingPeriods: [] as IReportingPeriodItem[],
        formTypes: [] as IFormTypeItem[],
        applicants: [] as IReport6Applicant[],
        isFormTypesSelectDisabled: true,
        formStructure: [] as IFormStructureSection[],
        flatFormStructure: [] as IFormStructureSection[],
        report7: [] as IReport7ApplicantPresentationModel[]
      }
    });

    this.getReportingPeriods().then(
      (reportingPeriods) =>
        this.output &&
        this.output.setReportingPeriods(
          reportingPeriods || ([] as IReportingPeriodItem[])
        )
    );
    return this.output;
  }
}
